import React from 'react'
import { Modal } from 'react-bootstrap'
import { Slide } from 'react-slideshow-image'
import 'react-slideshow-image/dist/styles.css'
import './slideshow.css'
import localization from "utils/localization"

const Slideshow = ({ images, onClose }) => {
    if (!images) return null
    return (
        <Modal show={ Boolean(images) } onHide={ onClose } size="xl" centered contentClassName='dialog'> 
            <Modal.Header closeButton style={{ backgroundColor: 'rgba(0, 0, 0, 0)', color: '#fff', border: '0px solid black' }} >
                <Modal.Title style={{ color: '#fff'}}>{ localization('project-images') }</Modal.Title>
            </Modal.Header>
            <div>
                <Slide transitionDuration={ 500 } easing='ease' canSwipe={ false } duration={ 9000 }>
                    { images.map((image, i) => <img key={ i } src={ image } alt='Project' style={{ width: '100%', height: '100%' }}/> )} 
                </Slide>
            </div>
        </Modal>
    )
}

export default Slideshow